import { FOOD_DATABASE } from "../types/actions";

const initialState = {
	foodDatabaseResult: [],
	foodDatabaseLevel2Result: [],
	foodDatabaseLevel3Result: [],
	foodDatabaseCardResult: [],
};

export default (state = initialState, action) => {
	switch (action.type) {
		case FOOD_DATABASE.GET_FOOD_DATABASE:
			return {
				...state,
				foodDatabaseResult: action.payload,
			};
		case FOOD_DATABASE.GET_FOOD_DATABASE_LEVEL_2:
			return {
				...state,
				foodDatabaseLevel2Result: action.payload,
			};
		case FOOD_DATABASE.GET_FOOD_DATABASE_LEVEL_3:
			return {
				...state,
				foodDatabaseLevel3Result: action.payload,
			};
		case FOOD_DATABASE.GET_FOOD_DATABASE_LEVEL_4:
			return {
				...state,
				foodDatabaseLevel4Result: action.payload,
			};
		case FOOD_DATABASE.GET_FOOD_LIST_CARD_VIEW:
			return {
				...state,
				foodDatabaseCardResult: action.payload,
			};

		case FOOD_DATABASE.GET_FOOD_DETAILS:
			return {
				...state,
				getFoodDetailsResult: action.payload,
			};
		case FOOD_DATABASE.GET_FOOD_NUTRITION:
			return {
				...state,
				foodNutritionList: action.payload,
			};
		case FOOD_DATABASE.GET_NUT_DATA:
			return {
				...state,
				nutData: action.payload,
			};
		case FOOD_DATABASE.GET_INGREDIENT_WEIGHTS:
			return {
				...state,
				ingredientWeights: action.payload,
			};
		// Reducer to handle actions for food list
		case FOOD_DATABASE.GET_FOOD_APPROVAL_LIST:
			return {
				...state,
				foodApprovalList: action.payload,
			};

		case FOOD_DATABASE.SEARCH_PATIENT_FOOD:
			return {
				...state,
				foodApprovalList: action.payload,
			};

		case FOOD_DATABASE.GET_PATIENT_FOOD_DETAILS:
			return {
				...state,
				getPatientFoodItem: action.payload,
			};
		default:
			return state;
	}
};
